export const mdmPaths = {
  MDM: "",
  DEVICE_GEO_LOCATION: "device-geo-location",
};
